import { createSlice } from "@reduxjs/toolkit";
// import { hasMatchingIds } from "../service/onboardingService";
import { RequiredDocuments } from "../utils/constants";

export const createBrandFormSlice = createSlice({
  name: "brandState",
  initialState: {
    brandStatus: true,
    EmailStatus:false,
address: {
    city: "",
    phoneNumber: "",
    street1: "",
    street2: "",
    street3: "",
    zip: ""
  },
attachments: [
],
brandLogoWithBg: 0,
brandName: "",
brandfeatured: true,
businessUnit: "",
emailAddress: "",
firstName: "",
lastName: ".",
migratedBrandId: 0,
tradeLiceneseNumber: ""
// documents: RequiredDocuments,

  },
  reducers: {
    // setDomain(state, action) {
    //   const selectedDomains = state.domains
    //   const domain = action.payload;
      
    //   let isAdd = true
    //   state.domains = selectedDomains.filter((d) => {
    //     if (domain.id == d.id) {
    //       isAdd = false
    //       if (domain.subCategory.length) {
    //         d.subCategory = domain.subCategory
    //         return d
    //       }
    //     } else {
    //       return d
    //     }
    //   })
    //   if (isAdd && domain.subCategory.length) {
    //     state.domains = [...selectedDomains, domain]
    //   }
    // },
    // updateDocuments(state,action)
    // {
  
    // //   if(hasMatchingIds(action.payload))
    // //   {
    // //     state.documents.forEach((item)=>
    // //     {
         
    // //     })
    // //   }
     
   
    // },
    updateValue(state, action) {
      console.log("State",state);
      console.log("action.payload.key",action.payload.key)
      console.log("action.payload.value",action.payload.value)
      console.log(" state[action.payload.key]", state[action.payload.key])
      if(action.payload.key==="address")
      {
        state[action.payload.key].city = action.payload.value
        state[action.payload.key].street1 = action.payload.value
        return
      }
      state[action.payload.key] = action.payload.value
return
      
    },
    updateAllValues(state, action) {
      console.log("updateAllValues called");
      console.log("Initial state:", state);
      console.log("action.payload",action.payload)
    
      Object.keys(state).forEach((key) => {
        console.log("Updating key:", key);
        if (action.payload.hasOwnProperty(key)) {
          // state[key] = action.payload[key];
        } else {
         if(key==="brandName")
         {
          state[key]= action.payload[0]["brandName"]
         }
         if(key==="businessUnit")
          {
           state[key]= action.payload[0].customFields["Business Unit"]
          }
          
          if(key==="brandfeatured")
            {
             state[key]= action.payload[0].customFields["Featured"]
            }
            if(key==="migratedBrandId")
              {
               state[key]= action.payload[0].customFields["Migrated BrandId"]
              }
               if(key==="emailAddress")
              {
               state[key]= action.payload[0]["email"]
              }
              if(key==="address")
                {
                  state.address.city = action.payload[0]["Address"]
                  state.address.street1 = action.payload[0]["Address"]
                }
                if(key==="tradeLiceneseNumber")
                  {
                   state[key]= action.payload[0]["taxId"]
                  }
         
        }
      });
    
      console.log("Updated state:", state);
    },
    updateMandatoryAndOptionalDoc(state, action) {
      state.documents = state.documents.map((doc) => {
        if (doc.id == action.payload.id) {
          return {
            url: action.payload.url,
            id: action.payload.id,
            docId: action.payload.docId,
            name: doc.name,
            mandatory: doc.mandatory
          }
        }
        return doc
      })
    },
    addAttachments(state, action) {
      if (!Array.isArray(state.attachments)) {
        state.attachments = [];
      }
      
       state.attachments = [
        ...state.attachments, 
        action.payload.id
      ];
    },

    addBrandLogo(state,action)
    {
      if(!state.brandLogoWithBg.id)
      {
        state.brandLogoWithBg=action.payload.id
      }

    },
    
    removeAddtionalDocument(state, action) {
      state.addtionalDocuments = state.addtionalDocuments.filter(doc => doc.id != action.payload.id)
    },
    checkUndertaking(state, action) {
      state.undertakings = state.undertakings.map(u => {
        if (u.id == action.payload.id) {
          u.checked = action.payload.checked
        }
        return u
      })
    },
    resetForm(state, action) {
      state.Status=true
      state.address=""
      state.attachments=[]
      state.brandLogoWithBg=0
      state.brandName=""
      state.brandfeatured= true
      state.businessUnit= ""
      state.emailAddress= ""
      state.firstName=""
      state.lastName= ""
      state.tradeLiceneseNumber=""
    }
  }
});

export const createBrandFormActions = createBrandFormSlice.actions;